export default __webpack_public_path__ + "static/media/File3.e7aef0be.pdf";